import { Group } from '../../entities/group/group.types';

export type FeedGroupCreationPreview = Group & {
  finalPriceHead: number;
  actualWeightTotal: number;
  dryWeightTotal: number;
};

export enum ChangedKeys {
  LOAD_WEIGHT = 'loadWeight',
  LOAD_WEIGHT_DRY = 'loadWeightDry',
  FEEDING_FACTOR = 'feedingFactor',
  GLOBAL_FEEDING_FACTOR = 'globalFeedingFactor',
  HEAD_COUNT = 'headCount',
  OTHER = 'other',
  FINAL_SAVE = 'finalSave',
}

export type PreviewBunkReaderScorePayload = {
  globalFeedingFactor?: number;
  actualWeightTotal?: number;
};
